<template>
    <reveal-view>
        <h2 slot="header" class="title">Atjaunot paroli</h2>
        <email-form @login="$modal.closeReveal()"></email-form>
    </reveal-view>
</template>

<script>
    import RevealView from '../common/RevealView'
    import EmailForm from './EmailForm'

    export default  {
        data() {
            return {
                email: ''
            }
        },
        components: { RevealView, EmailForm }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/auth/EmailReveal.vue